import { Directive, InjectionToken, TemplateRef, inject } from '@angular/core';

/** Context passed to `[sbInputComplexRow]` templates. */
export interface SbComplexRowContext {
  $implicit: Record<string, unknown>;
  row: Record<string, unknown>;
  index: number;
  update: (key: string, value: unknown) => void;
  patch: (partial: Record<string, unknown>) => void;
  add: () => void;
  remove: () => void;
  disabled: boolean;
}

/** What a date or time field in a row tells the rows around it. Its own control is standalone, so no form hears it. */
export interface SbComplexRows {
  /** The field holds half-typed text, or no longer does: the value it wrote for that is `''`, not what it shows. */
  rowEntryChanged(entry: object, unfinished: boolean): void;
  /** The field went with its row. */
  rowEntryGone(entry: object): void;
}

export const SB_COMPLEX_ROWS = new InjectionToken<SbComplexRows>('SbComplexRows');

/**
 * Marks an `ng-template` as the row body for `app-sb-input-complex-multiple`.
 * Prefer this over the `fields` config when you need arbitrary nested controls.
 *
 * @example
 * ```html
 * <app-sb-input-complex-multiple [(ngModel)]="items" [emptyItem]="{ title: '', note: '' }">
 *   <ng-template sbInputComplexRow let-row let-update="update">
 *     <div class="col-md-6">
 *       <app-sb-input-text label="Title" [ngModel]="row['title']" (ngModelChange)="update('title', $event)"></app-sb-input-text>
 *     </div>
 *   </ng-template>
 * </app-sb-input-complex-multiple>
 * ```
 */
@Directive({ selector: '[sbInputComplexRow]' })
export class SbInputComplexRowDirective {  template = inject<TemplateRef<SbComplexRowContext>>(TemplateRef);

}
